// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"591640a9","1195":"9b90924b","2781":"591640a9","3732":"591640a9","5693":"9b90924b","6978":"9b90924b","8891":"591640a9","9807":"9b90924b"}[chunkId] + ".chunk.css";
};